import './AllDriversButtons.css';
import { AiFillCloseCircle } from "react-icons/ai";
import Dropdown from 'react-bootstrap/Dropdown';

const AllDriversButtons = ({listOfDrivers,selectedDriverId, setSelectedDriverId}) => {

  return (
    <div className='AllDriversButtonsContainer'>
        {listOfDrivers && listOfDrivers?.map( (one) => {
            return <div key={one.id} style={one.id === selectedDriverId ? {background: '#eee' } : {}} className="oneDriverIcon" onClick={()=> setSelectedDriverId(one.id)}>
                        <p>{one.nick}</p>
                    </div>
        })}
        {selectedDriverId && <div className="oneDriverIcon" onClick={()=> setSelectedDriverId(false)}>
                        <p>Všichni řidiči</p>
                    </div> }
    </div>
  )
}

export default AllDriversButtons
